import React, {Component} from "react";
import {Field, reduxForm} from "redux-form/immutable";
import ActionButton from "../../../components/ActionButton";
import FormFieldsTable from "../../../components/forms/FormFieldsTable";
import DropDownInputField from "../../../components/forms/DropDownInputField";
import FormError from "../../../components/forms/FormError";

class WarehouseBackupForm extends Component {

  render() {
    let {errors, handleSubmit, submit, warehouses, submitting} = this.props;
    let submitLabel = submitting ? "Standby..." : "Submit"; 

    return (
      <form onSubmit={handleSubmit}>
        <div className="fields">
          <FormFieldsTable>
            <Field 
              label="Warehouse"
              name="backupWarehouseId"
              component={DropDownInputField}
              data={warehouses}
              valueKey="id"  
              titleKey="id" 
              showBlank={true}
              serverError={this.props.errors.backupWarehouseId}
              />
          </FormFieldsTable>
        </div>
        <FormError error={errors._error} />
        <div className="buttons">
          <ActionButton label={submitLabel} onClick={submit} active={!submitting} />
          <ActionButton label="Cancel" active={!submitting} onClick={this.props.onCancel} />
        </div>
      </form>
    )
  }
}

const ReduxForm = reduxForm({
  form: "WarehouseBackupForm"
})(WarehouseBackupForm);

export default ReduxForm;